export const DEFAULT = 'default chat'
export const CLOSED = 'closed chat'
export const WAITING = 'waiting chat'
export const MEDIA_CALL = 'media call'
export const MEDIA_VIDEO = 'media video'
export const MEDIA_SCREEN_SHARE = 'media screen share'
export const MEDIA_CALL_REQUEST = 'media call request'
export const MEDIA_VIDEO_REQUEST = 'media video request'
export const MEDIA_SCREEN_SHARE_REQUEST = 'media screen share request'
